<div id="showing-timeselect-container" class="prospect-grid-container">
  <div id="showing-timeselect-options-cont">
    <p>When would you like to schedule your showing?</p>
    <div id="showing-timeselect-selecteddate-div">
      <div id="selected-showing-date">{{selectedDateString}}</div>
      <div id="change-showing-date" (click)="changeDate()">CHANGE DATE</div>
    </div>
    <div id="loaderDiv"><div *ngIf="showLoader" class="loader"></div></div>
    <div class="flex flex-col justify-center text-center">
      <mat-selection-list #show [multiple]="false">
        <mat-list-option *ngFor="let show of showings let i = index" (click)="selectShowing(i)" [value]="show">
          {{show.StartTimeString}}
        </mat-list-option>
      </mat-selection-list>
    </div>
    <button mat-flat-button color="primary" class=" w-full my-4 font-normal text-2xl sm:text-base" [disabled]="selectedShowing === null || isProcessing" (click)="onSubmit()">NEXT</button>
  </div> 
</div>



